import { render, staticRenderFns } from "./modal-product-existed.vue?vue&type=template&id=5453e7f6&scoped=true"
import script from "./modal-product-existed.vue?vue&type=script&lang=js"
export * from "./modal-product-existed.vue?vue&type=script&lang=js"
import style0 from "./modal-product-existed.vue?vue&type=style&index=0&id=5453e7f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5453e7f6",
  null
  
)

export default component.exports